import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'colorPreference'

const OPTIONS = [
  {
    value: 'Bold & expressive',
    translationKey: 'pages.onboarding.colorPreference.options.bold',
    subtextKey: 'pages.onboarding.colorPreference.subtexts.bold',
    emoji: '🌈',
  },
  {
    value: 'Neutral & calm',
    translationKey: 'pages.onboarding.colorPreference.options.neutral',
    subtextKey: 'pages.onboarding.colorPreference.subtexts.neutral',
    emoji: '🌫️',
  },
  {
    value: 'Mix it up',
    translationKey: 'pages.onboarding.colorPreference.options.mix',
    subtextKey: 'pages.onboarding.colorPreference.subtexts.mix',
    emoji: '🎨',
  },
]

export default function ColorPreferencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    // Find the selected option to get both value and subtext
    const selectedOption = OPTIONS.find((option) => option.value === value)
    const emoji = selectedOption ? selectedOption.emoji : ''

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Do you prefer bold or subtle colors?',
      answer_key: value,
      answer: `${emoji} , ${t(selectedOption?.translationKey ?? '')}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.colorPreference.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
